import { publishMenuModule } from "./ps";

const KEYS = {
  // 菜单导航
  MENUS: 'menus',
  MENU_MODULE: 'menuModule',
  FROM_URL: 'fromUrl',
  // 字典模块
  DICT_QUERY: 'dictQuery',
  
  // 用户租户相关
  TENANT_CONFIGURATION: 'tenantConfiguration',
  TARGET_NAME: 'targetName',
  
  // 用户信息
  ACCESS_TOKEN: 'token',
  IS_JS: 'isJs',
  USER_INFO: 'userInfo',
  USER_CODE: 'userCode',
  USER_NAME: 'userName',
  ROLE_CODE: 'roleCode',
  TENANT_CODE: 'tenantCode',
  
  // 登录路径
  LOGIN_PATH: 'loginPath',
  // 登录时是否钩选同意协议
  CHECK_AGREEMENT: 'checkAgreement',

  // 侧栏
  SIDER_WIDTH: 'siderWidth',

  // 项目
  PROJECT_ID: 'projectId',
  PROJECT_CODE: 'projectCode',
  PROJECT_ROLE_CODE: 'projectRoleCode',
  PROJECT_EDIT_ITEM: 'photoEditItem',

  // 受试者
  SUBJECT_STATE: 'subjectState',

  // 访视
  VISIT_INFO: 'visitInfo',

  // 表单
  FORMS: 'localStorage_forms',
  FORM_VALUES: 'localStore_formData',
  FORCE_READONLY: 'forceReadonly',

  // 外呼
  WEB_AGENT_V2: 'webAgentV2',
  DEBUG_PHONE_NUMBER: 'debugPhoneNumber',

  // 阿里云OSS
  ALIOSS_OPTIONS: 'aliossOptions',

  // 下载相关
  DATA_SOURCE_DOWNLOAD: 'dataSourceDownload',
  CUSTOMER_DATA_DOWNLOAD: 'customerDataDownload',

  // 其他
  VID_AUDIT_SEARCH: 'videoAuditSearch',

  // 齐鲁肿瘤提示弹窗
  QL_ALERT: 'qlAlert',
}

type ScalarType = string | number | boolean | null

const readStorage = (key: string, defaultValue: ScalarType = null, adapter = sessionStorage): ScalarType=> {
  const value = adapter.getItem(key)

  if (null === value) {
    return defaultValue
  }
  if (value === 'null:null') {
    return null
  }
  if (value.startsWith('numeric')) {
    return Number(value.slice(8))
  }
  if (value.startsWith('bool:')) {
    return value === 'bool:true'
  }
  return value
}
const writeStorage = (key: string | [string, ScalarType][], data?: ScalarType, adapter = sessionStorage)=> {

  if (Array.isArray(key)) {
    for(const [k, v] of key) {
      writeStorage(k, v)
    }
    return
  }

  if (typeof data === 'undefined') {
    return
  }

  if (typeof data === 'number') {
    data = `numeric:${data}`
  } else if (typeof data === 'boolean') {
    data = `bool:${data}`
  } else if (data === null) {
    data = 'null:null'
  }
  adapter.setItem(key, data)
}

const removeStorage = (key: string | string[], removeAll = false)=> {
  if (Array.isArray(key)) {
    for(const k of key) {
      sessionStorage.removeItem(k)
      if (removeAll) {
        localStorage.removeItem(k)
      }
    }
  } else {
    sessionStorage.removeItem(key)
    if (removeAll) {
      localStorage.removeItem(key)
    }
  }
}

const readJsonStorage = <T>(key: string, name?: keyof T, defaultValue: unknown = null, adapter = sessionStorage): T | unknown => {
  try {
    const value = adapter.getItem(key)
    if (null === value) {
      return defaultValue
    }
    const data = JSON.parse(value) as T
    if (typeof name === 'string') {
      return data[name] ?? defaultValue
    }
    return data
  } catch (error) {
    console.warn('readJsonStorage', error)
    return defaultValue
  }
}

const writeJsonStorage = (key: string| [string, unknown][], data?: unknown, adapter = sessionStorage)=> {
  if (Array.isArray(key)) {
    for(const [k, v] of key) {
      adapter.setItem(k, JSON.stringify(v))
    }
  } else {
    adapter.setItem(key, JSON.stringify(data))
  }
}

export const clearStorage = (clearAll = false)=> {
  sessionStorage.clear()
  if (clearAll) {
    localStorage.clear()
  }
}

/**
 * sessionStorage 统一管理
 * 租户配置缓存管理
 * 
 */
interface TenantConfiguration {
  // 端午活动
  enableDuanWuActivity: null | boolean
  // ？
  enableInterest: null | boolean
  // ？
  enableMenu: null | boolean
  // ？
  enableNewUi: null | boolean
  // 隐藏100个适应症医学项目实际访视时间
  hiddenVisitDate: null | boolean
  // 隐藏神州细胞数据审计列表中的所在医院、上传医生、医生账号列
  hiddenField: null | boolean
  // 君实修改受试者为患者
  label: null | string
  // 根据租户跳转默认页面
  route: string
  [key: string]: unknown
}

export const readTenantConfiguration = (name?: keyof TenantConfiguration, defaultValue: unknown = null)=> {
  return readJsonStorage<TenantConfiguration>(KEYS.TENANT_CONFIGURATION, name, defaultValue)
}

export const writeTenantConfiguration = (data: TenantConfiguration)=> {
  writeTargetName(data.label || '受试者')
  writeJsonStorage(KEYS.TENANT_CONFIGURATION, data)
}
export const readTargetName = ()=> readStorage(KEYS.TARGET_NAME, '受试者')
export const writeTargetName = (value: string)=> writeStorage(KEYS.TARGET_NAME, value)

/**
 * sessionStorage 统一管理
 * 系统菜单
 */
export interface MenuModuleType {
  levelOneIndex: number
  levelOneKey: string
  levelOneTitle: string
  levelThreeKey?: string
  levelThreeTitle?: string
  levelTwoKey?: string
  levelTwoTitle?: string
  levelTwoUrl?: string
  selectMenuKey?: string
  selectMenuUrl?: string
  selectOpenMenuKey?: string
  dynamicMenuUrlParams?: {
    id: string
    code: string
  }
  [key: string]: unknown
}

export const readMenuModule = (name?: keyof MenuModuleType, defaultValue: unknown = null): MenuModuleType | unknown | null=> readJsonStorage(KEYS.MENU_MODULE, name, defaultValue)

export const writeMenuModule = (data: MenuModuleType)=> writeJsonStorage(KEYS.MENU_MODULE, data)

export const updateMenuModule = (sets: Partial<MenuModuleType>, publishEvent = true)=> {
  const data = readMenuModule(undefined, {}) as MenuModuleType

  if (Object.keys(sets).length === 0) {
    return data
  }

  for(const name in sets) {
    data[name] = sets[name]
  }

  writeMenuModule(data)

  // 触发
  if (publishEvent) {
    publishMenuModule()
  }

  return data
}

export const clearMenuModule = (sets: Partial<MenuModuleType> = {levelThreeTitle: ''})=> {
  if (readStorage(KEYS.MENU_MODULE)) {
    updateMenuModule(sets)
  }
}

/**
 * 菜单
 */
export interface MenuRecord {
  children: MenuRecord[]
  config: string
  iconName: string | null
  key: string
  code?: string
  title: string
  type: string
  url: string
}
export const readMenus = ()=> readJsonStorage(KEYS.MENUS, undefined, []) as MenuRecord[]
export const writeMenus = (data: MenuRecord[])=> writeJsonStorage(KEYS.MENUS, data)

/**
 * 路径跳转
 */
export const readFromUrl = ()=> readStorage(KEYS.FROM_URL) as string
export const writeFromUrl = (value: string)=> writeStorage(KEYS.FROM_URL, value)
export const removeFromUrl = ()=> removeStorage(KEYS.FROM_URL)

/**
 * 侧栏宽度
 */
export const readSiderWidth = (defaultValue = 200)=> readStorage(KEYS.SIDER_WIDTH, defaultValue) as number
export const writeSiderWidth = (value: number)=> writeStorage(KEYS.SIDER_WIDTH, value)
export const removeSiderWidth = ()=> removeStorage(KEYS.SIDER_WIDTH)

/**
 * 字典
 */
interface DictQuery {
  name: string
  identification: string
  createUser: string
  type: string
  state: string
}
export const readDictQuery = ()=> readJsonStorage(KEYS.DICT_QUERY) as DictQuery
export const writeDictQuery = (data: DictQuery)=> writeJsonStorage(KEYS.DICT_QUERY, data)
export const removeDictQuery = ()=> removeStorage(KEYS.DICT_QUERY)

/**
 * sessionStorage 统一管理
 * 登录用户信息
 */
export interface UserInfo {
  roleCode: string
  roleCodes: string[]
  userCode: string
  userName: string
  tenantName: string
  tenantCode: string
}
export const readUserInfo = (name?: keyof UserInfo, defaultValue: unknown = null)=> {
  return readJsonStorage<UserInfo>(KEYS.USER_INFO, name, defaultValue)
}
export const writeUserInfo = (data: UserInfo)=> {
  writeUserCode(data.userCode)
  writeUserName(data.userName)
  writeRoleCode(data.roleCode)
  writeJsonStorage(KEYS.USER_INFO, data)
}
export const readUserCode = ()=> readStorage(KEYS.USER_CODE) as string
export const writeUserCode = (value: string)=> writeStorage(KEYS.USER_CODE, value)
export const readUserName = (defaultValue = '')=> readStorage(KEYS.USER_NAME, defaultValue) as string
export const writeUserName = (value: string)=> writeStorage(KEYS.USER_NAME, value)
export const readRoleCode = ()=> readStorage(KEYS.ROLE_CODE) as string
export const writeRoleCode = (value: string)=> writeStorage(KEYS.ROLE_CODE, value)
export const readTenantCode = ()=> readStorage(KEYS.TENANT_CODE, null, localStorage) as string
export const writeTenantCode = (value: string)=> writeStorage(KEYS.TENANT_CODE, value, localStorage)
export const readAccessToken = ()=> readStorage(KEYS.ACCESS_TOKEN) as string
export const writeAccessToken = (value: string)=> writeStorage(KEYS.ACCESS_TOKEN, value)
export const isLogged = ()=> !(readStorage(KEYS.ACCESS_TOKEN) === null)

/**
 * 登录钩选协议
 */
export const readCheckAgreement = (defaultValue = false)=> readStorage(KEYS.CHECK_AGREEMENT, defaultValue, localStorage) as boolean
export const writeCheckAgreement = (value: number)=> writeStorage(KEYS.CHECK_AGREEMENT, value, localStorage)

/**
 * 登录路径
 */
export const readLoginPath = (defaultValue = '/login')=> readStorage(KEYS.LOGIN_PATH, defaultValue) as string
export const writeLoginPath = (value: string)=> writeStorage(KEYS.LOGIN_PATH, value)

/**
 * 当前打开的患者详情页面
 */
export interface ProjectData {
  // 表单ID
  formId: number
  subjectCode: string
  subjectName: string | null
  subjectIcon: string
  joinDate: string
  createUser: string
  projectName: string
  projectCode: string
  projectType: string
  groupCode: string
  groupName: string | null
  subjectState: string | null
  auditState: string | null
  signState: string | null
  commentState: string | null
  progress: ('Wait' | 'Complete')[]
  singleSignState: string | null
  centerName: string
  tasks: {
    "type": string
    "state": string
    "message": string
    "number": number
  }[];  
}
export const readProjectItem = (name?: keyof ProjectData, defaultValue: unknown = null)=> readJsonStorage<ProjectData>(KEYS.PROJECT_EDIT_ITEM, name, defaultValue)
export const writeProjectItem = (data: ProjectData)=> writeJsonStorage(KEYS.PROJECT_EDIT_ITEM, data)

/**
 * 项目角色编码
 */
export const readProjectRoleCode = ()=> readStorage(KEYS.PROJECT_ROLE_CODE)
export const writeProjectRoleCode = (value: string)=> writeStorage(KEYS.PROJECT_ROLE_CODE, value)
export const removeProjectRoleCode = ()=> removeStorage(KEYS.PROJECT_ROLE_CODE)

/**
 * 项目编码
 */
export const readProjectId = (defaultValue: number = 0)=> readStorage(KEYS.PROJECT_ID, defaultValue) as number
export const writeProjectId = (value: number)=> writeStorage(KEYS.PROJECT_ID, value)
export const readProjectCode = (defaultValue: string = '')=> readStorage(KEYS.PROJECT_CODE, defaultValue) as string
export const writeProjectCode = (value: string)=> writeStorage(KEYS.PROJECT_CODE, value)

/**
 * 受试者
 */
export const readSubjectState = ()=> readStorage(KEYS.SUBJECT_STATE) as string
export const writeSubjectState = (value: string)=> writeStorage(KEYS.SUBJECT_STATE, value)


/**
 * 访视
 */
export interface VisitInfoType {
  appointmentDate: string | null
  customize: boolean
  formPass: string
  id: number
  lockState: string
  name: string
  planDate: string | null
  question: boolean
  scaleNum: string | null
  scales: unknown[]
  state: string
  type: string
  visitDate: string
  forms: unknown[]
}
export const readVisitInfo = (name?: keyof VisitInfoType, defaultValue: unknown = null)=> readJsonStorage(KEYS.VISIT_INFO, name, defaultValue)
export const writeVisitInfo = ({ forms, ...data }: VisitInfoType)=> writeJsonStorage(KEYS.VISIT_INFO, data)

/**
 * 表单
 */
export interface Forms {
  activeId: number
  state: string
  forms: {
    id: number
    title: string
    formCode: string
    visitName: string
    inputState: string
  }[]
}
export const readForms = (name?: keyof Forms, defaultValue: unknown = null)=> readJsonStorage<Forms>(KEYS.FORMS, name, defaultValue, localStorage)
export const writeForms = (data: Forms)=> writeJsonStorage(KEYS.FORMS, data, localStorage)

/**
 * 表单编辑时缓存
 */
type FormDataType = {
  formId: number
  init: boolean
  submit: boolean
  values: {
    dataCode: string
    deCode: string
    value: string | string[] | {min: string; max: string; other: string; radio: string} 
    question: boolean
    subjectCode: string
    projectCode: string
    inputState: string
  }[]
}

export const readFormValues = ()=> readJsonStorage(KEYS.FORM_VALUES, undefined, []) as FormDataType[]
export const writeFormValues = (data: FormDataType[])=> writeJsonStorage(KEYS.FORM_VALUES, data)
export const removeFormValues = ()=> removeStorage(KEYS.FORM_VALUES)

/**
 * 君实强制只读
 */
export const readForceReadonly = ()=> readStorage(KEYS.FORCE_READONLY, false) as boolean
export const writeForceReadonly = (value = true)=> writeStorage(KEYS.FORCE_READONLY, value)
export const removeForceReadonly = ()=> removeStorage(KEYS.FORCE_READONLY)

/**
 * 外呼
 */
export interface AgentInfo {
  // 坐席分机
  agentDn: string
  // 坐席工号
  agentId: string
  // 坐席密码 MD5加密
  agentPwd: string
  // 企业ID
  entId: string
}
export const readWebAgentV2 = (name?: keyof AgentInfo, defaultValue: unknown = null)=> readJsonStorage<AgentInfo>(KEYS.WEB_AGENT_V2, name, defaultValue)
export const writeWebAgentV2 = (data: AgentInfo)=> writeJsonStorage(KEYS.WEB_AGENT_V2, data)

/**
 * 外呼临时测试手机号
 */
export const readDebugPhoneNumber = (defaultValue: string)=> readStorage(KEYS.DEBUG_PHONE_NUMBER, defaultValue) as string

/**
 * 阿里云OSS参数
 */
interface AliOssOptions {
  accessKeyId: string;
  accessKeySecret: string;
  bucket: string;
  region: string;
  stsToken: string;
}
export const readAliOssOptions = ()=> {
  const value = readJsonStorage(KEYS.ALIOSS_OPTIONS) as { data: [string, AliOssOptions], expire: number } | null

  if (!value) {
    return null
  }

  // 有效期1小时
  const now = (new Date().getTime() / 1000)

  const {expire, data} = value

  return expire > now ? data : null
}
export const writeAliOssOptions = (data: [string, AliOssOptions])=> {
  // 有效期1小时
  const expire = (new Date().getTime() / 1000) + 3000
  // 
  writeJsonStorage(KEYS.ALIOSS_OPTIONS, {
    data,
    expire,
  })
}


/**
 * 下载相关
 */
export const readDataSourceDownload = ()=> readStorage(KEYS.DATA_SOURCE_DOWNLOAD, false) as boolean
export const writeDataSourceDownload = (value = true)=> writeStorage(KEYS.DATA_SOURCE_DOWNLOAD, value)
export const removeDataSourceDownload = ()=> removeStorage(KEYS.DATA_SOURCE_DOWNLOAD)
export const readCustomerDownload = ()=> readStorage(KEYS.CUSTOMER_DATA_DOWNLOAD, false) as boolean
export const writeCustomerDownload = (value = true)=> writeStorage(KEYS.CUSTOMER_DATA_DOWNLOAD, value)
export const removeCustomerDownload = ()=> removeStorage(KEYS.CUSTOMER_DATA_DOWNLOAD)

/**
 * 其他
 */
export const readVideoAuditSearch = ()=> readJsonStorage(KEYS.VID_AUDIT_SEARCH)
export const writeVideoAuditSearch = (data: unknown)=> writeJsonStorage(KEYS.VID_AUDIT_SEARCH, data)
export const removeVideoAuditSearch = ()=> removeStorage(KEYS.VID_AUDIT_SEARCH)

// 齐鲁
export const readQlAlert = ()=> readStorage(KEYS.QL_ALERT)
export const writeQlAlert = ()=> writeStorage(KEYS.QL_ALERT, true)
export const removeQlAlert = ()=> removeStorage(KEYS.QL_ALERT)